import React from 'react';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper, 
  Typography, 
  Box,
  CircularProgress
} from '@mui/material';
import { callUIAPI } from '../../utils/apiUtils';
import { showErrorMessage } from '@/shared/components/toast-system';

class ContentTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      votes: []
    };
  }

  componentDidMount() {
    this.fetchTotalVotes();
  }

  async fetchTotalVotes() {
    this.setState({ isLoading: true });
    try {
      const response = await callUIAPI('bo/votes/total', null, 'get', true);
      console.log('Total votes response:', response);
      this.setState({ votes: response.data.totalVotes || [] });
    } catch (error) {
      console.error('Error fetching total votes:', error);
      showErrorMessage('Failed to fetch content type votes.');
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { isLoading, votes } = this.state;

    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Content Types Voting Summary
        </Typography>
        
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><strong>Content Type Name</strong></TableCell>
                  <TableCell align="right"><strong>Total Votes</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {votes.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2} align="center">
                      No votes found.
                    </TableCell>
                  </TableRow>
                ) : (
                  votes.map((vote, index) => (
                    <TableRow key={index}>
                      <TableCell>{vote.contentTypeName}</TableCell>
                      <TableCell align="right">{vote.voteCount}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
    );
  }
}

export default ContentTypes;